import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientMedicationsSelector } from '../selectors'
import { setPatientMedicationsList } from '../store/patientMedications.actions'
import { PatientMedicationsConstants } from '../store/patientMedications.constants'
import { IPatientMedicationsState } from '../store/patientMedications.types'

export function* setName() {
  const patientMedications: IPatientMedicationsState = yield select(getPatientMedicationsSelector)
  const { name, patientMedication, patientMedicationsList } = patientMedications
  const selectedMedication = patientMedicationsList.filter((medication) => medication.key === patientMedication?.key)
  if (selectedMedication && selectedMedication.length) {
    selectedMedication[0].name = name
    yield put(setPatientMedicationsList(patientMedicationsList))
  }
}
export function* setNameSaga() {
  yield takeLatest([PatientMedicationsConstants.SET_NAME], setName)
}
